import React, {
    useState
} from "react";
import PermissionTab from "./PermissionTab";
import UserPasswordTab from "./UserPasswordTab";

const UserSecurityTabs = ({

    user,

    permissions,

    setPermissions,

    loading,

    loadPermissions
}) => {

    const [activeTab, setActiveTab] = useState("permissions");

    return (

        <div className="card shadow-sm">

            <div className="card-header bg-white">

                <ul className="nav nav-tabs card-header-tabs">

                    <li className="nav-item">

                        <button
                            className={`nav-link ${
                                activeTab === "permissions"
                                    ? "active"
                                    : ""
                            }`}
                            onClick={() =>
                                setActiveTab("permissions")
                            }
                        >

                            Permissions

                        </button>

                    </li>

                    <li className="nav-item">

                        <button
                            className={`nav-link ${
                                activeTab === "password"
                                    ? "active"
                                    : ""
                            }`}
                            onClick={() =>
                                setActiveTab("password")
                            }
                        >

                            Password

                        </button>

                    </li>

                    <li className="nav-item">

                        <button
                            className={`nav-link ${
                                activeTab === "audit"
                                    ? "active"
                                    : ""
                            }`}
                            onClick={() =>
                                setActiveTab("audit")
                            }
                        >

                            Audit

                        </button>

                    </li>

                </ul>

            </div>

            <div
                className="card-body"
                style={{
                    minHeight: "500px"
                }}
            >

                {

                    activeTab === "permissions" &&

                    <PermissionTab

                         user={user}

                        permissions={permissions}

                        setPermissions={setPermissions}

                        loading={loading}

                        loadPermissions={loadPermissions}

                    />

                }

                {

                    activeTab === "password" &&

                    <UserPasswordTab

                        user={user}

                        loadPermissions={loadPermissions}

                    />

                }

                {

                    activeTab === "audit" &&

                    <div>

                        Audit tab coming later...

                    </div>

                }

            </div>

        </div>

    );

};

export default UserSecurityTabs;